import React from 'react';
import { Timer, RotateCcw, Play } from 'lucide-react';

const GameTimer = ({
    timeLeft,
    formatTime,
    gameTimer,
    onShowGameInfo,
    onNewGame,
    onAnotherRound,
    t
}) => {
    const isTimeUp = timeLeft === 0;
    const timerTone = timeLeft <= 60 ? 'text-spy-danger' : timeLeft <= 180 ? 'text-spy-primary' : 'text-spy-text';

    return (
        <div className="border-t border-spy-border pt-6 text-center">
            <div>
                <p className="mb-3 text-[10.5px] font-semibold uppercase tracking-[0.22em] text-spy-primary">
                    Live Round
                </p>
                <h2 className="mb-6 font-display text-[32px] font-medium leading-tight text-spy-text">
                    {t.roundTimer}
                </h2>

                {/* Large Timer Display */}
                <div className={`mb-6 font-display text-[64px] font-semibold leading-none ${timerTone}`}>
                    {formatTime(timeLeft)}
                </div>

                {/* Progress Circle */}
                <div className="relative w-32 h-32 mx-auto mb-8">
                    <svg className="h-32 w-32 -rotate-90 transform" viewBox="0 0 36 36">
                        <path
                            className="text-spy-border2"
                            stroke="currentColor"
                            strokeWidth="2"
                            fill="transparent"
                            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                        />
                        <path
                            className={`transition-all duration-1000 ${timerTone}`}
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            fill="transparent"
                            strokeDasharray={`${(timeLeft / (gameTimer * 60)) * 100}, 100`}
                            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                        />
                    </svg>
                    <div className="absolute inset-0 flex items-center justify-center">
                        <Timer className={`h-8 w-8 ${timerTone}`} />
                    </div>
                </div>

                {/* Time Up Alert */}
                {isTimeUp && (
                    <div className="mb-6 border-y border-spy-border py-4">
                        <h3 className="mb-2 font-display text-[24px] font-semibold text-spy-danger">
                            {t.timeUp}
                        </h3>
                        <p className="text-sm text-spy-muted">
                            {t.discussAndVote}
                        </p>
                    </div>
                )}

                {/* Buttons */}
                <div className="space-y-3">
                    {/* Game Info Button - Only show when time is up */}
                    {isTimeUp && (
                        <button
                            onClick={onShowGameInfo}
                            className="min-h-[48px] w-full rounded-spy bg-spy-text px-6 py-3 text-[15px] font-semibold text-spy-bg hover:opacity-90"
                        >
                            {t.revealLocation}
                        </button>
                    )}

                    {/* Another Round - Only show when time is up */}
                    {isTimeUp && (
                        <button
                            onClick={onAnotherRound}
                            className="flex min-h-[48px] w-full items-center justify-center space-x-2 rounded-spy border border-spy-border2 bg-transparent px-6 py-3 text-[15px] font-semibold text-spy-soft hover:border-spy-primary hover:text-spy-primary"
                        >
                            <Play className="w-5 h-5" />
                            <span>{t.anotherRound}</span>
                        </button>
                    )}

                    {/* New Game Button */}
                    <button
                        onClick={onNewGame}
                        className="flex min-h-[48px] w-full items-center justify-center space-x-2 rounded-spy border border-spy-border2 bg-transparent px-6 py-3 text-[15px] font-semibold text-spy-muted hover:border-spy-danger hover:text-spy-danger"
                    >
                        <RotateCcw className="w-5 h-5" />
                        <span>{t.newGame}</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default GameTimer;
